import * as React from "react";
import * as moment from "moment";
// @ts-ignore
import { Chart } from "chart.js";
Chart.defaults.LineWithLine = Chart.defaults.line;
Chart.controllers.LineWithLine = Chart.controllers.line.extend({
    draw: function (ease: any) {
        Chart.controllers.line.prototype.draw.call(this, ease);

        if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
            let activePoint = this.chart.tooltip._active[0],
                ctx = this.chart.ctx,
                x = activePoint.tooltipPosition().x,
                topY = this.chart.legend.bottom,
                bottomY = this.chart.chartArea.bottom;

            // draw line
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, topY);
            ctx.lineTo(x, bottomY);
            ctx.lineWidth = 2;
            ctx.strokeStyle = "#07C";
            ctx.stroke();
            ctx.restore();
        }
    }
});


export interface ILegend {
    color: string,
    text: string
}

interface ILineChartProps {
    header?: string,
    legends?: ILegend[],
    dayEpoch: any,
    readings: { x: string, y: number }[],
    idealRange?: { min: number, max: number },
    scatteredPointsData?: number[],
    pointBackgroundColors?: string[],
}

const LineChart = (props: ILineChartProps) => {
    const chartRef: any = React.createRef();

    React.useEffect(() => {
        const myChartRef = chartRef.current.getContext("2d");
        const start = new Date(props.dayEpoch);
        start.setHours(0, 0, 0, 0);
        const end = new Date(props.dayEpoch);
        end.setHours(24, 0, 0, 0);

        let datasets = []
        if (props.readings) {
            datasets.push({
                data: props.readings.map(reading => ({ t: reading.x, y: reading.y })),
                fill: false,
                borderColor: "#e4306e",
                pointBorderColor: "transparent",
                //can pass array for pointBackgroundColor for multiple colors
                pointBackgroundColor: props.pointBackgroundColors ? [...props.pointBackgroundColors] : "transparent",
                borderWidth: 1
            })
        }

        if (props.idealRange && props.idealRange.min) {
            datasets.push({
                data: [
                    { t: moment(props.dayEpoch).hours(0).minutes(0).seconds(0).format("YYYY-MM-DD HH:mm:ss"), y: props.idealRange.min },
                    { t: moment(props.dayEpoch).hours(24).minutes(0).seconds(0).format("YYYY-MM-DD HH:mm:ss"), y: props.idealRange.min }
                ],
                borderDash: [10, 10],
                borderColor: "#30B129",
                fill: "+1",
                pointBorderColor: "transparent",
                pointBackgroundColor: "transparent",
                hideInLegendAndTooltip: true,
                backgroundColor: "rgba(134, 203, 107, 0.18)",
                borderWidth: 1
            })
        }

        if (props.idealRange && props.idealRange.max) {
            datasets.push({
                data: [
                    { t: moment(props.dayEpoch).hours(0).minutes(0).seconds(0).format("YYYY-MM-DD HH:mm:ss"), y: props.idealRange.max },
                    { t: moment(props.dayEpoch).hours(24).minutes(0).seconds(0).format("YYYY-MM-DD HH:mm:ss"), y: props.idealRange.max }
                ],
                borderDash: [10, 10],
                borderColor: "#30B129",
                fill: false,
                pointBorderColor: "transparent",
                pointBackgroundColor: "transparent",
                hideInLegendAndTooltip: true,
                borderWidth: 1
            })
        }

        new Chart(myChartRef, {
            type: "line",
            data: {
                datasets
                // Bring in data
                // datasets: [
                //     {
                //         data: [
                //             { t: "2021-01-05 00:00:00", y: 135.5 },
                //             { t: "2021-01-05 01:00:00", y: 125 },
                //             { t: "2021-01-05 02:30:00", y: 110 },
                //             { t: "2021-01-05 03:00:00", y: 90 },
                //             { t: "2021-01-05 04:00:00", y: 75 },
                //             { t: "2021-01-05 05:00:00", y: 90 },
                //             { t: "2021-01-05 06:00:00", y: 110 },
                //             { t: "2021-01-05 07:00:00", y: 100 },
                //             { t: "2021-01-05 08:00:00", y: 92 },
                //             { t: "2021-01-05 09:00:00", y: 104 },
                //             { t: "2021-01-05 10:00:00", y: 132 },
                //             { t: "2021-01-05 11:00:00", y: 170 },
                //             { t: "2021-01-05 12:00:00", y: 162 },
                //             { t: "2021-01-05 13:00:00", y: 140 },
                //             { t: "2021-01-05 14:00:00", y: 100 },
                //             { t: "2021-01-05 15:00:00", y: 70 },
                //             { t: "2021-01-05 16:00:00", y: 60 },
                //             { t: "2021-01-05 17:00:00", y: 71 },
                //             { t: "2021-01-05 18:00:00", y: 89 },
                //             { t: "2021-01-05 19:00:00", y: 100 },
                //             { t: "2021-01-05 20:00:00", y: 120 },
                //             { t: "2021-01-05 21:00:00", y: 140 },
                //             { t: "2021-01-05 22:00:00", y: 100 },
                //             { t: "2021-01-05 23:00:00", y: 90 },
                //             { t: "2021-02-05 00:00:00", y: 140 }
                //         ],
                //         fill: false,
                //         borderColor: "#e4306e",
                //         pointBorderColor: "transparent",
                //         pointBackgroundColor: "transparent"
                //     },
                //     {
                //         data: [
                //             { t: "2021-01-05 00:00:00", y: 80 },
                //             { t: "2021-01-06 00:00:00", y: 80 }
                //         ],
                //         borderDash: [10, 10],
                //         borderColor: "#3199d6",
                //         fill: "+1",
                //         pointBorderColor: "transparent",
                //         pointBackgroundColor: "transparent",
                //         hideInLegendAndTooltip: true,
                //         backgroundColor: "#ffd0d6"
                //     },
                //     {
                //         data: [
                //             { t: "2021-01-05 00:00:00", y: 140 },
                //             { t: "2021-01-06 00:00:00", y: 140 }
                //         ],
                //         borderDash: [10, 10],
                //         borderColor: "#3199d6",
                //         fill: false,
                //         pointBorderColor: "transparent",
                //         pointBackgroundColor: "transparent",
                //         hideInLegendAndTooltip: true
                //     }
                // ]
            },
            options: {
                // Customize chart options
                tooltips: {
                    filter: function (tooltipItem: any) {
                        return tooltipItem.datasetIndex === 0;
                    }
                },
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 10
                    }
                },
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                suggestedMin: 0,
                                fontSize: 9,
                                // max: 250
                            },
                            gridLines: {
                                drawBorder: false
                            },
                            distribution: "series"
                        }
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontSize: 9,
                            },
                            id: "x-as",
                            type: "time",
                            time: {
                                unit: "hour",
                                unitStepSize: 2,
                                displayFormats: { hour: "hA" },
                                ticks: {
                                    stepSize: "h"
                                },
                                max: end,
                                min: start,
                                distribution: "series"
                            }
                        }
                    ]
                }
            }
        });
    }, []);

    return (
        <div className={"line-chart-container"}>
            <div className={"line-chart-header"}>
                <span className={"line-chart-heading"}>{props.header || ""}</span>
                <div className={"line-chart-legends"}>
                    {(props.legends || []).map((legend: ILegend) => {
                        return (<article>
                            <span className={"color-indicator"} style={{ backgroundColor: legend.color }} />
                            <span className={"desc"}>{legend.text}</span>
                        </article>)
                    })}
                </div>
            </div>
            <div style={{ width: "auto", height: "200px", position: "relative" }}>
                <canvas id="myChart" ref={chartRef as any} style={{ width: "100%", height: "100%" }} />
            </div>
        </div>
    );
}

export default LineChart
